import React from 'react';
import { connect } from 'dva';
import { routerRedux } from 'dva/router';
import { Button } from 'antd';

import intl from 'react-intl-universal';
import { isbindAE } from './util';

import {oberloReport} from 'utils/utils'

import styles from './Index.less';
import pricingimg from 'assets/pricingCallback.png'
import Media from 'react-media';
import MobileHeader from 'routes/Pricing/Mobile/Header';


import { setOberloGuidePop } from '../../services/oberloGuilde';
@connect(({ guidance, loading, global ,auth, topBtn, login}) => ({
  guidance,
  loading: loading.models.guidance,
  AEInfo: global.AEInfo,
  migrationInfo:auth?.migrationInfo,
  dsers_oberlo_plan: topBtn.fromOberloPlan,
  userInfo: login.userInfo
}))
class Pricing extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    let url;
    const after = window.location.search;
    const urlData = after.substring(after.lastIndexOf('=') + 1);
    const payment = JSON.parse(localStorage.getItem('payment')) || {};

    if (urlData) {
      url = urlData;
    } else {
      url = payment.charge_id;
    }

    this.props.dispatch({
      type: 'guidance/activate',
      payload: {
        data: {
          charge_id: Number(url)
        }
      }
    });
  }

  Access = () => {
    if (isbindAE(this.props.AEInfo) && (localStorage.getItem('noMigra') != 'false') && !this.props.userInfo.ae_flag) {
      this.props.dispatch(routerRedux.push('/bind/ae'));
      return;
    }
    // if (localStorage.getItem('noMigra') == 'false') {
    //   if (!localStorage.getItem('reducePlan')){
    //        window.location.href = '/app/'; // 首页
    //   }
    //   setOberloGuidePop({
    //     data: { name: 'isBindPlan', value: 'true' }
    //   }).then(() => {
    //     if(this.props.dsers_oberlo_plan?.compare){
    //       oberloReport('show_plan_btn', 'true').then(()=>{
    //         window.location.href = '/app/'; 
    //       })
    //     }else{
    //       window.location.href = '/app/'; 
    //     }
    //   })
    // } 
    // else 
    // {
      window.location.href = '/app/'; // 首页
    // }
  };

  render() {
    return (
      <>
        {
          this.props.isMobile ?
            <div className={styles.reminder_2}>
              <MobileHeader/>
              <div className={styles.img}>
                <img src={pricingimg} alt="" />
              </div>
              <div className={styles.text_2}>{intl.get('pricing.AccessText')}</div>
              <div className={styles.buttonc}>
                <Button
                  data="dx"
                  style={{ borderRadius: 10 }}
                  onClick={this.Access}
                  type="primary"
                >
                  {intl.get('pricing.Access')}
                </Button>
              </div>
            </div>
            :
            <div className={styles.reminder}>
              <div className={styles.img}>
                <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHUAAAAiCAYAAAEWiKZlAAAAAXNSR0IArs4c6QAAEBdJREFUaAXtW3l4VcUVn3NfFkAkuCtLi3xZWBSoVlvUUmitVkUtVlE07vhZFLJgVepW6lprbRaoYj9xBxWXUhEr9fusOxZBQEQhiVIpEZCCJEggyXt3+jvz3kzmzrtvScTqH97ve5mZs82cOWfOnDtzI+T9Q/eVVUX3yXlD80TikdVFVQzT7ZSlrBn6HUaC4Q9+VaGUNSXjZXXJsJQMFoKYmcpXr2cYM3uVDcQlCXqYKusv4jrj0D5XCjmXekV6yeZYM9N5jHAfRoDwQoYTeTcn2nNV+9K1O3QHhln3Cl3PSPS8My5UXqJx8bZS8R+UExko1GQ5k6Ng9w0+RBOnLLVObpmSwUKYYSu9agvPJBLzXUF2W9YWDtH8ObrCBFTWQGg/zTDNABMulFJNOGa85z5UtmI742V14ZuKmQm5Z5vJbtOIfrlCNDBasB8I6U+kivpjlZ2l3/qJwlh/NDOD9Cg0mnLzDqPJH6zW7a6URmW7I6i52NZEC7ZpGIa5y5cxsVvjudQ0zA+nfB2+9iOG2YPntjGUzSw8OY3b8s9DC7lkQur7vRxm5p+sKv6FwqNT3ZGm49I8XmSajTdwVIzGDNSjgha8hC6mK1c3yJricdL3n5WNyzv4yP8pGvNtHl2nvvn5NH51myL2u33Apawpukb6cUdR7arCCgpEC5IrqaLhHsVk/ZHVxUcJKSdqENb45brelTIw71oA3PNRqmy4gNtwXR8erTxW41NNncZnKs0Ua0HKdkKcLx8ZNokueG+n7lDjMwnMBm861cQsXHW8teULwIyG0Hgjpj4Qh7QfaF6KiAIEgGYbjmj5mJR+qabhMtyLLQqtITQ+2BYm4RBMRl7kJEMTE00WK8IzPU8VdedrGNOpnwakK5kQHh1lGt0x/LFK8fjUxDB0sE53rmUhGp3KdcrLVzPEdPLeYQcmaQpvfkkREm3VzKpdWY8Ql/xQ5ZrF1KOgtxjet1gPyKXC8tukByR3t2w2NtUMiCaKB6Pcnysa7gpiIYzjn2zBrK4IzGyA3JWRpCnmcZEeVYAz0eAIpeEYmOGHxzWk4sPUv6R+nriDaVJuAFqwLiknZxhNWbNKt+0SWxMhdvs2zK3viU3DldnZtpmtTIwyGn0P5uFEpQorYaqmRxzZC4rysjYPnP1pEAY2IxGJqv3ZEH0NlSRlw1xCzhh0OCvL40OMqUR4+BUidA813m27xtjjhqKvYls4y4alq2OiHoBnXGzTwPXmwlXPs2Fct9cCjxO8r4J3FMc+HYoAex2w41zeUDcOU5YZVUa9o9VEDsrNHUCTP/xE4WqKbsXmeb3bAUW8EVRWt9KFc9seeBhew+zxpOJhZUVu7iTZ1rpD87klyzEL3UW6bZq4elsAFm0/WrepvP4GNXNI4DWMSxnzV/AAebYD8KpC5CrxBwNV+TtVlEYQpDrSDaA5PdV0bonAtEopwIEHGwzCbmApMT1kX6hpVJvfROwMlZGuYG67CUUqOs2LfWQRwvoJus2l5rEtxDCkzGOkH3uZaeDC5XDhWjlzyFA3C7b5VJ5eGc/Tmc9+MNYZ2Jkn2zDq3a970pq1CbhDEW1fhjWQD2bzcB5oGqkqPXqNFS1N8VzRoYFC1ZCp0gKlAPlj9UTIqhG9lTe0t7GrQ3mxGTnMwY6IpKacd1ZE7NyiN+Sraeem6bI9+l9D2NS4PlRZPYMSHdoPUeR0qlj7nA2DBc+ABZ+xYVxXG68F1MowCJarlDNKamU09jG3ZUw+z4qpuujwRiRiI5GIva0Qmf5sXHEV4sadYWSYsM/R54HBJNymJMIalS+DSKU1NiqsDkuRqCmZinBdHIb/sol7mMzOwEITf1cAXA4ZZjzhc3HchmVrYdkpYTgNs62qYf/PMqsoDGuNVevnwdHd3MHJmYOPyKSky/N1tEPXaaqByO0bdgEXjNDR9jdtelh/HUgCMBv/ddUDivI7DNaSjmDYXg47SMjWDbCYocMe2Qg37qsHjKgcsDJwAzXum1QaBcIGRRXvbwY8F8o1wX17MQ3KPjgb6Rm2YSs88mJ+v+Z6pkdWDRqAuV2OyeqtaREldwvP+zGyrCUaxiX2yWtB93uuk+dNECKyTPrtddzW6x+HQSfgGGURw+yH09Ws1iisVGAzira2B3UbQhboOpcS7/SyetCJNiysjjz6SSmi62wlFT88BBnWvzC5rwb48CJmt7WSGiZri48PU1Ljs1KUiTHTJo2DK5+pBcDVT9N1XUoZfRGKvK/bbgncJRj1eBdut+E5o3AolXTepGik/5hNq+ox+fckmAXIWlEh6S2LL1CNn4YGQJzEDlWRet7I7kEMrC7EbA3jDZ1dj3/k0dUarkopJpo279OJB14Q4SqOqI8zbmvFEbj2KVqmkltZPzp7RUnk6Y7cksa8ElUCBSWtTdm4pUXOLtlb88iZg/bTdS6R5u3LJdbgbchu7uI6P5iA+VgyHX06rsunEjRlrYnumKQH4pyQ5fsLIa9OpYcJYNaKwpV+oAWlKuHGPbG93Oji+WrCwGL+yboe34owsKqiDbDSdR1w72hMwDjdDitp/FNmKTEeb1SXQp5JGSGvCGe5USisXDorRWXNoCPtziDwcbtt12GFW3FcZiyocZBxjKpLv8NKQrQqGEmVvCOwtSlXzPE+5iRf82Zbou+RfFTHcjQPFP45AtuajIqqYxQ/ulQzqnJvL+2BM289fIYU4PFjxaqdm2+iKbxkkIKV1+di8p6FR8TfjtpjK6X44nO1xqsLHw7IydDg40GWA9dX1wRMjn5K0u6jsqbwbmwXU23Z7G6Eyy4bFlpvb58egOflvcFtDKRBv61wG267FTJ53f5StdV7pTQJiSjoh0nFtY8VjJjOfaSbnjZ/uhWL1ZCFKsozyRQWnWGAeww0DVQ0rQ3jOragAIgV1AC41gydH6Pc15YBVzMPwuwquviV+AEcByMbaajilUR66kA7mhldV5Ni1tVdp253poQb3W7Tw7XKIO8jG+bWMRk7cDA3zIV3pc3nWaEWtYVhkDFcMxxHZfUmotn4THUS3lU44/mTSwfPKMRN14XYCh5KwglxBSbjXheero2Jc9+bm/H6sRDR+EHmy/qAO1UnbGngFmLju4fK69Q6TEWbDRxnSafj2OFWeGkwmGXDDJpvwkF6lkP9ysgyem+mnhG9+cVmAmLFBA6oMHI7pnYqPHZmJl4bj2vTO3BuPg2Hgzb423oXZiDr2JutbBg5F8aZwRsH8pKnpZyesQ8ka39jg2bbx7d06WcgbfhVewzld2QK1NoT4g4QvhiK1YgvH+TJCJPd0ncBSo/OQ7yfG0YHw4+CI5j80KXBGJ4Uw/uV8quSi/u2HT4D6cMv7oKpIv7lmMPORjAnATiFP1ZE/aeQr6kLf4cWaaWcg5ODIXxR5eLgGEXJMAuSk3fLV21Qed+RuWL3jlHoFS8c0MGXvZF4NCGj3YL95F3RvddSunxZizWqtFVZMxg6+eajMEOcJ5fSpLpG3cb52WhBsaPQxvdu8h1kheb9WtNwGX+TZHlyAMbUB7/w6EdUh23v7vQr1TkNtTsKq2NfPBth9IkwHMNwdHIOOn3SxuMg7wDknJuQ2ocPlPkELRHdup9Kk977zObtah2RgUR1yW+RJk5DPf6mmIUwRA0Mkx4Wffa/gsYv3pWKJfE91p0uPn6YmfuW8FvfgKD+Nh5zY+68GY65/B3m8iabJlMd88R39aNTTmQmAWF4NhjuxUrDcAom5Wy1KiwC3KFtEXn5JUiw4ucPFk5XEQGO5q9usPf6CNdV/HmfxnW2xGQ9Chn4BM7/bWcMyv1gqyHwXKROxqoKl3X6XET6P+Gbategrg7Q8+XOGtSWsUeNyoJhpDl4i1bH6nZHXIdx9hItO7/vwtWbep8Re4Fvnouz24lJrcDp9W4Yhn84ksjugTP1wBHHFkxWSqfjiADnmoUV+QjG8m46yTDMEUJ8sZVv3pLoUhyRYPyXubS8+vH7HLOjjlXxVXUJ6Ma4dNxGbnIbFs0RlOMNDvsJL+8Cpku/pzJFlx5ai0HGD8lcfi82HKDFLjhxrHk2Jr9U7Gr+I1ZEmUtjtxOrbBay7FkcdsR+3U9Jexe0q+k1GGJ/WwbXMaEteLkdQeUf1ts4OMxYzPcjmODQD0tg/H8Lj87GVzzJxs9wHATj3IT84ha7P1PvM6yBGlfsVAvAABMVX07GfdV6cfDw2e4xsE26R/dUFqwOzj9djhWRYjIi3ihcogW+3LEHZNdx4F8sojFMbOZzdebDRD+B05sJtgyu830YXxW5cF4l2Ml78/esio73d58eR3/I7JMfOE8b6K+BQWqSsR0QhE9zKdgBjdewr16GQ5r7XbjdhmMXwLFxASkPteFuHeOvxzqfhn30WRu351dq4/K5WBEpvFtsF4f3wSoNjc72uFSdJq9hwh9yA3shskR/DpwlZbaMSTgH93jHiorSAUTTfSVE/Ykicwx5JL4fLatvVv+R8mnbR/h+ph96SiKEs/wVO8cllOILqBAGLLRkOYpO5i1IoncAyLSbABoYH1drJdz1BujGr5OBJz4X8pnEoc86EaGTaUrdmj1mVHWl1hxbClXCwy4Ph7xJXX09QRL2DiQUJxSdD4VOCmiYaKD//lQ9h/eWhwzew11A6EGVPF5d749X3+P1h+Nchz33NuaDITFJ3nhc6S3VcrAn3wVr/Vrh+WqRxAbUN8APlmG1XKvp0pYyJ2VC6PIl/suBs2iVSePV8VAR8++CgdW1h02vVnVUfojrl+lfOlHiEIn9ZwlfH6YzKBKPSoSdlK879gDT1ZWinvebdDRwnm02HuF1gdoDbSDqGK8n2lu3cHLCKDjO7dT3gB7qPhjXMwGDVhfN0gZlWt7zMJFIahCqPbGSYeZJkSgZfBcrGM86bC9nxj8qDX7bb0T6dHXWKxX7RGJPogJo9F0odQgLwneIRl5YRe1DJH6GwbwWhlcHF7HYjWG4ZBi+1pViCL756JuMi0NgvC2ifM0CUQE3sp/c/FHU3voRjJBrg7HicSIWWwP9YGOaLzZufUHWFm1EP/1xcjYELzGloNkHfDabqeNm5jo4a+hpmSHqRCXdfqzFyOrHdDWsfDd7o0pxYlxCuHKudJWESO96qqy7w8UF2lH/IEhMyA5gQhrp+4ZB2wU+9UCZREhXvv8f3Lb2ou2Nb8MhOQMPPLAZvECOw144LogItEwDfTSLCPoK+9eMDNmvERJW+RK8mPP1OBg5MWujhvUfBoOyL+Ajmgr3FSGMVsE8GMD6b7iUdBkQ6PdxUX5eaTBBCjIlbqBH8P8sidYW3pdHBikytzBxy7DXlnJCkpn6q6eA3u1wxL+Ibj1ujp+4NaS/T0XoNB9N8q0LDxEwThA2was3I52ux7vaiyI3fxFdsQov0J1/kHyEfvWdSpJaIUJsRP8fI5t5Dho8o06lUjFkgKtbpNq5x2BiTgPpYMg9BKG3AJpug56f4bcE9X+KsnPfSucwdjcI1SReGROxYbre1URR82dT/g+CB2Ak3GcbFwAAAABJRU5ErkJggg==" />
              </div>
              <div className={styles.text}>{intl.get('pricing.AccessText')}</div>
              <div className={styles.buttonc}>
                <Button
                  data="dx"
                  style={{ borderRadius: 10 }}
                  onClick={this.Access}
                  type="primary"
                >
                  {intl.get('pricing.Access')}
                </Button>
              </div>
            </div>
        }
      </>
    );
  }
}

export default (props => (
  <Media
    queries={{
      small: '(max-width: 599px)',
    }}
  >
    {matches => (
      <Pricing
        {...props}
        isMobile={matches.small}
      />
    )}
  </Media>
));